import underline from 'markdown-it-plugin-underline';
import React from 'react';
import { Platform, StyleSheet, Text } from 'react-native';
import { default as MD, MarkdownIt } from 'react-native-markdown-display';

import { useColors, useFont } from '../../hooks';

interface MarkdownProps {
  children: any;
  style?: any;
}

// TODO: remove this when react-native-markdown-display is updated
const MDany = MD as any;

const markdownItInstance = MarkdownIt({ typographer: true }).use(underline);
const rules = {
  u: (node, children, _, styles) => {
    return (
      <Text key={node.key} style={styles.u}>
        {children}
      </Text>
    );
  },
};

export function Markdown({ children, style }: MarkdownProps) {
  const colors = useColors();
  const fonts = useFont();
  const fontSize = StyleSheet.flatten(style)?.fontSize || 16;

  return (
    <MDany
      markdownit={markdownItInstance}
      rules={rules}
      style={{
        table: { borderWidth: 0 },
        tr: { borderBottomWidth: 0 },
        paragraph: style,
        bullet_list_icon: {
          ...Platform.select({
            ios: {
              fontSize: 50,
              lineHeight: 54,
            },
            web: {
              fontSize: fontSize * 1.8,
              marginTop: 6,
            },
            android: {
              fontSize: 34,
              lineHeight: 46,
            },
          }),
          color: colors.darkGray,
        },
        em: {
          ...fonts.primary.bold,
          color: colors.primary,
        },
        u: {
          ...fonts.primary.regular,
          textDecorationLine: 'underline',
        },
      }}
    >
      {children}
    </MDany>
  );
}
